<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0 py-5">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Distributor Activation
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title"> List </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="goBack()">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon> Back
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="area"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
            disable-pagination
            :hide-default-footer="true"
          >
            <template slot="body.append">
              <tr>
                <th>Total</th>
                <th class="text-center">
                  {{ setToLocaleString(getTotal(table.data), 0) }}
                </th>
              </tr>
            </template>
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.name`]="{ item }">
              <a href="#" @click.prevent="showDetails(item)">{{ item.name }}</a>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <distributor-activation-details
      ref="dealerList"
    ></distributor-activation-details>
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
import DistributorActivationDetails from "../dialogs/acquisition/DistributorActivationDetails.vue";

export default {
  mixins: [ShareableMethods],
  name: "DistributorActivation",
  components: {
    DistributorActivationDetails,
  },
  data() {
    return {
      menu: false,
      modal: false,
      dates: [
        moment(Date.now()).format("YYYY-MM-DD"),
        moment(Date.now()).format("YYYY-MM-DD"),
      ],
      search: "",
      table: {
        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          { text: "Distributor", value: "name" },
          { text: "Count", align: "center", value: "count" },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      const payload = {
        startDate: this.dates[0],
        endDate: this.dates[1],
      };
      await this.$drs
        .post(`/broker/pf-int/distributor-count`, payload)
        .then((response) => {
          const newArr = response.data;
          console.log(newArr);
          this.table.data = newArr.data.sort(function (a, b) {
            return b["count"] - a["count"];
          });
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    showDetails(item) {
      this.$refs.dealerList.open(item, this.dates);
      // console.log(item);
    },

    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },

    getTotal(data) {
      // console.log(data.count.replace(/[, ]+/g, " ").trim())
      return data.reduce((partialSum, a) => partialSum + parseInt(a.count.replaceAll(',', '')), 0);
    },
  },

  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    dates(e) {
      if (e.length > 1) {
        this.getList();
      }
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
